export enum ChainId {
  BSC = 56,
  BSC_TESTNET = 97,
  GODE2 = 5500,
  GODE = 5500,
  GODE_TESTNET = 5566,
}
